import { render, staticRenderFns } from "./LinkSageCustomerPopUp.vue?vue&type=template&id=f60e0228&scoped=true&"
import script from "./LinkSageCustomerPopUp.vue?vue&type=script&lang=js&"
export * from "./LinkSageCustomerPopUp.vue?vue&type=script&lang=js&"
import style0 from "./LinkSageCustomerPopUp.vue?vue&type=style&index=0&id=f60e0228&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f60e0228",
  null
  
)

export default component.exports